import { Link } from 'react-router-dom';
import * as S from './styles';
import * as T from 'common/types';

const PrimaryButton: React.FC<T.Form.Button> = ({
  link,
  disabled,
  style,
  onClick,
  target,
  className,
  type,
  children
}) => {
  return (
    <>
      {link ? (
        <S.PrimayButtonLinkC className={className}>
          {target ? (
            <a href={link} target={target} style={style}>
              {children}
            </a>
          ) : (
            <Link to={!disabled ? link : '#'} style={style} className={disabled ? 'disabled' : ''}>
              {children}
            </Link>
          )}
        </S.PrimayButtonLinkC>
      ) : (
        <S.PrimayButtonC className={className} type={type} onClick={onClick} disabled={disabled} style={style}>
          {children}
        </S.PrimayButtonC>
      )}
    </>
  );
};

export default PrimaryButton;
